webpackJsonp([277036910692064],{

/***/ 285:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/current-projects.1fa60740.svg";

/***/ }),

/***/ 286:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/pricing-policy-1.847bd557.svg";

/***/ }),

/***/ 463:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(8);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__(11);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _GlobalFunctions = __webpack_require__(24);
	
	var _navigation = __webpack_require__(13);
	
	var _navigation2 = _interopRequireDefault(_navigation);
	
	var _footer = __webpack_require__(12);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	var _pricingPolicy = __webpack_require__(286);
	
	var _pricingPolicy2 = _interopRequireDefault(_pricingPolicy);
	
	var _currentProjects = __webpack_require__(285);
	
	var _currentProjects2 = _interopRequireDefault(_currentProjects);
	
	var _registerNow = __webpack_require__(142);
	
	var _registerNow2 = _interopRequireDefault(_registerNow);
	
	var _cover = __webpack_require__(19);
	
	var _cover2 = _interopRequireDefault(_cover);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Pricing_policy = function (_React$Component) {
		(0, _inherits3.default)(Pricing_policy, _React$Component);
	
		function Pricing_policy() {
			(0, _classCallCheck3.default)(this, Pricing_policy);
	
			var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this));
	
			_this.state = {
				average: '',
				averageOrders: ''
			};
			return _this;
		}
	
		Pricing_policy.prototype.pageClick = function pageClick(e) {
			document.getElementsByTagName('body')[0].className = '';
		};
	
		Pricing_policy.prototype.fixedSidebar = function fixedSidebar() {
	
			var sidebar = document.getElementById('sidebar'),
			    sidebar_scroll = document.getElementById('sidebar-scroll'),
			    content = document.getElementById('content');
			var scrTop = window.pageYOffset,
			    formOuterH = getAbsoluteHeight(sidebar_scroll),
			    formH = sidebar_scroll.clientHeight,
			    contentH = content.clientHeight,
			    contentOfTop = getElementTop(content),
			    sidebarH = sidebar.clientHeight,
			    sidebarOfTop = getElementTop(sidebar),
			    contentB = contentH + contentOfTop;
	
			if (window.innerHeight > 767) {
				if (contentH > sidebarH + formOuterH) {
					sidebar_scroll.parentNode.setAttribute('style', 'min-height:' + formOuterH + 'px');
					if (scrTop >= sidebarOfTop - 70) {
						sidebar_scroll.setAttribute('data-fixed', true);
	
						if (contentB < scrTop + formH + 70) {
							sidebar_scroll.setAttribute('style', 'top:' + -(scrTop + formH - contentB) + 'px');
						} else {
							sidebar_scroll.setAttribute('style', 'top:70px');
						}
					} else {
						sidebar_scroll.setAttribute('style', 'top:auto');
						sidebar_scroll.removeAttribute('data-fixed');
					}
				}
			}
	
			function getElementTop(e) {
				for (var t = e.offsetTop, a = e.offsetParent; null != a;) {
					t += a.offsetTop, a = a.offsetParent;
				}return t;
			}
	
			function getAbsoluteHeight(t) {
				t = "string" == typeof t ? document.querySelector(t) : t;var e = window.getComputedStyle(t),
				    o = parseFloat(e.marginTop) + parseFloat(e.marginBottom);return Math.ceil(t.offsetHeight + o);
			}
		};
	
		Pricing_policy.prototype.componentDidMount = function componentDidMount() {
			var self = this,
			    mask = document.getElementById('mask');
			mask.addEventListener('touchstart', this.pageClick, false);
	
			this.fixedSidebar;
	
			window.addEventListener('scroll', this.fixedSidebar, false);
	
			window.addEventListener('resize', this.fixedSidebar, false);
	
			(0, _GlobalFunctions.getJSON)('GET', '/api/orders/available/total', null, function (data) {
				if (typeof data === 'string') data = JSON.parse(data);
				self.setState({ average: data.avg });
				self.setState({ averageOrders: data.count });
			}, function (status) {});
		};
	
		Pricing_policy.prototype.componentWillUnmount = function componentWillUnmount() {
			window.removeEventListener('scroll', this.fixedSidebar);
			window.removeEventListener('resize', this.fixedSidebar);
		};
	
		Pricing_policy.prototype.render = function render() {
			return _react2.default.createElement(
				"div",
				null,
				_react2.default.createElement(_reactHelmet2.default, {
					title: "Pricing policy for various types of academic writing assignments - UvoCorp.com",
					meta: [{ name: "description", content: "View pricing policy and determine the sum of money you can get depending on the type of writing assignment and the deadline." }, { property: 'og:title', content: "Pricing policy for various types of academic writing assignments - UvoCorp.com" }, { property: 'og:description', content: "View pricing policy and determine the sum of money you can get depending on the type of writing assignment and the deadline." }, { property: 'og:site_name', content: "UvoCorp.com" }, { property: 'og:type', content: "website" }, { property: 'og:image', content: _cover2.default }],
					link: [{ rel: 'canonical', href: "https://www.uvocorp.com/prices.html" }] }),
				_react2.default.createElement(
					"div",
					{ className: "header", id: "header" },
					_react2.default.createElement(_navigation2.default, null)
				),
				_react2.default.createElement(
					"div",
					{ className: "wrapper" },
					_react2.default.createElement(
						"div",
						{ className: "inner-header" },
						_react2.default.createElement(
							"div",
							{ className: "container" },
							_react2.default.createElement(
								"h1",
								null,
								"Pricing Policy"
							),
							_react2.default.createElement(
								_gatsbyLink2.default,
								{ to: "/register_email.html" },
								"Register now"
							)
						)
					),
					_react2.default.createElement(
						"div",
						{ className: "inner-white" },
						_react2.default.createElement(
							"div",
							{ className: "container" },
							_react2.default.createElement(
								"div",
								{ id: "content", className: "col-md-8" },
								_react2.default.createElement(
									"h2",
									{ className: "left" },
									"What is the price for your writing abilities?"
								),
								_react2.default.createElement(
									"p",
									null,
									"If you are looking for the well-paid job, this is a right place to be at. We offer the highest rates for the writing job and pay twice a month in a very timely manner. Start from the easiest papers and move up the career ladder to complete a full dissertation."
								),
								_react2.default.createElement(
									"p",
									null,
									"These tables show prices per page, they are different depending on the college level of the assignment and deadline for completion."
								),
								_react2.default.createElement(
									"div",
									{ className: "inner-table" },
									_react2.default.createElement(
										"h3",
										{ className: "inner-table-header" },
										"English as a Second Language Writers"
									),
									_react2.default.createElement(
										"ul",
										{ className: "inner-table-tbody" },
										_react2.default.createElement(
											"li",
											{ className: "inner-table-tr inner-table-tr-1" },
											_react2.default.createElement(
												"ul",
												{ className: "inner-table-column" },
												_react2.default.createElement(
													"li",
													{ className: "inner-table-column-th" },
													"Urgent Assignments ",
													_react2.default.createElement(
														"span",
														null,
														"(deadline of 24 hours or less)"
													)
												),
												_react2.default.createElement(
													"li",
													{ className: "inner-table-column-td" },
													"$ 7.00 - 8.00"
												),
												_react2.default.createElement(
													"li",
													{ className: "inner-table-column-td" },
													"$ 9.00 - 11.00"
												),
												_react2.default.createElement(
													"li",
													{ className: "inner-table-column-td" },
													"$ 10.00 - 12.00"
												),
												_react2.default.createElement(
													"li",
													{ className: "inner-table-column-td" },
													"$ 13.00 - 15.00"
												),
												_react2.default.createElement(
													"li",
													{ className: "inner-table-column-td" },
													"$ 15.00"
												)
											)
										),
										_react2.default.createElement(
											"li",
											{ className: "inner-table-tr" },
											_react2.default.createElement(
												"ul",
												{ className: "inner-table-column" },
												_react2.default.createElement(
													"li",
													{ className: "inner-table-column-th" },
													"Other Assignments ",
													_react2.default.createElement(
														"span",
														null,
														"(deadline of more than 24 hours)"
													)
												),
												_react2.default.createElement(
													"li",
													{ className: "inner-table-column-td" },
													"$ 5.00"
												),
												_react2.default.createElement(
													"li",
													{ className: "inner-table-column-td" },
													"$ 6.00"
												),
												_react2.default.createElement(
													"li",
													{ className: "inner-table-column-td" },
													"$ 7.00"
												),
												_react2.default.createElement(
													"li",
													{ className: "inner-table-column-td" },
													"$ 9.00"
												),
												_react2.default.createElement(
													"li",
													{ className: "inner-table-column-td" },
													"$ 11.00"
												)
											)
										)
									)
								),
								_react2.default.createElement(
									"div",
									{ className: "inner-table" },
									_react2.default.createElement(
										"h3",
										{ className: "inner-table-header" },
										"Pricing for Complicated Assignments ",
										_react2.default.createElement(
											"span",
											null,
											"(Engineering, Computer Science, etc)"
										)
									),
									_react2.default.createElement(
										"ul",
										{ className: "inner-table-tbody" },
										_react2.default.createElement(
											"li",
											{ className: "inner-table-tr inner-table-tr-1" },
											_react2.default.createElement(
												"ul",
												{ className: "inner-table-column" },
												_react2.default.createElement(
													"li",
													{ className: "inner-table-column-th" },
													"Urgent Assignments ",
													_react2.default.createElement(
														"span",
														null,
														"(deadline of 24 hours or less)"
													)
												),
												_react2.default.createElement(
													"li",
													{ className: "inner-table-column-td" },
													"$ 9.80 - 11.20"
												),
												_react2.default.createElement(
													"li",
													{ className: "inner-table-column-td" },
													"$ 12.60 - 15.40"
												),
												_react2.default.createElement(
													"li",
													{ className: "inner-table-column-td" },
													"$ 14.00 - 16.80"
												),
												_react2.default.createElement(
													"li",
													{ className: "inner-table-column-td" },
													"$ 18.20 - 21.00"
												),
												_react2.default.createElement(
													"li",
													{ className: "inner-table-column-td" },
													"$ 21.00"
												)
											)
										),
										_react2.default.createElement(
											"li",
											{ className: "inner-table-tr" },
											_react2.default.createElement(
												"ul",
												{ className: "inner-table-column" },
												_react2.default.createElement(
													"li",
													{ className: "inner-table-column-th" },
													"Other Assignments ",
													_react2.default.createElement(
														"span",
														null,
														"(deadline of more than 24 hours)"
													)
												),
												_react2.default.createElement(
													"li",
													{ className: "inner-table-column-td" },
													"$ 7.00"
												),
												_react2.default.createElement(
													"li",
													{ className: "inner-table-column-td" },
													"$ 8.40"
												),
												_react2.default.createElement(
													"li",
													{ className: "inner-table-column-td" },
													"$ 9.80"
												),
												_react2.default.createElement(
													"li",
													{ className: "inner-table-column-td" },
													"$ 12.60"
												),
												_react2.default.createElement(
													"li",
													{ className: "inner-table-column-td" },
													"$ 15.40"
												)
											)
										)
									)
								),
								_react2.default.createElement(
									"div",
									{ className: "inner-table" },
									_react2.default.createElement(
										"h3",
										{ className: "inner-table-header" },
										"English as a Native Language Writers"
									),
									_react2.default.createElement(
										"ul",
										{ className: "inner-table-tbody" },
										_react2.default.createElement(
											"li",
											{ className: "inner-table-tr inner-table-tr-1" },
											_react2.default.createElement(
												"ul",
												{ className: "inner-table-column" },
												_react2.default.createElement(
													"li",
													{ className: "inner-table-column-th" },
													"Urgent Assignments ",
													_react2.default.createElement(
														"span",
														null,
														"(deadline of 24 hours or less)"
													)
												),
												_react2.default.createElement(
													"li",
													{ className: "inner-table-column-td" },
													"$ 12.00 - 14.00"
												),
												_react2.default.createElement(
													"li",
													{ className: "inner-table-column-td" },
													"$ 15.00 - 18.50"
												),
												_react2.default.createElement(
													"li",
													{ className: "inner-table-column-td" },
													"$ 16.50 - 21.00"
												),
												_react2.default.createElement(
													"li",
													{ className: "inner-table-column-td" },
													"$ 22.00 - 26.00"
												),
												_react2.default.createElement(
													"li",
													{ className: "inner-table-column-td" },
													"$ 26.50"
												)
											)
										),
										_react2.default.createElement(
											"li",
											{ className: "inner-table-tr" },
											_react2.default.createElement(
												"ul",
												{ className: "inner-table-column" },
												_react2.default.createElement(
													"li",
													{ className: "inner-table-column-th" },
													"Other Assignments ",
													_react2.default.createElement(
														"span",
														null,
														"(deadline of more than 24 hours)"
													)
												),
												_react2.default.createElement(
													"li",
													{ className: "inner-table-column-td" },
													"$ 7.50 - 9.50"
												),
												_react2.default.createElement(
													"li",
													{ className: "inner-table-column-td" },
													"$ 9.00 - 11.00"
												),
												_react2.default.createElement(
													"li",
													{ className: "inner-table-column-td" },
													"$ 11.00 - 13.00"
												),
												_react2.default.createElement(
													"li",
													{ className: "inner-table-column-td" },
													"$ 14.50 - 16.50"
												),
												_react2.default.createElement(
													"li",
													{ className: "inner-table-column-td" },
													"$ 17.50 - 21.00"
												)
											)
										)
									)
								),
								_react2.default.createElement(
									"p",
									{ className: "inner-table-supinfo" },
									"Prices in these tables are calculated as general and may vary in the real orders."
								),
								_react2.default.createElement(
									"p",
									null,
									"We offer the highest rates for your writing skills and the best career opportunities for you. Start off as an ESL or ENL normal writer and become a called-for Advanced Writer."
								),
								_react2.default.createElement(
									"p",
									null,
									"There are two main categories of writers who can apply for a job in our company ESL and ENL writers."
								),
								_react2.default.createElement(
									"p",
									null,
									"ESL writers are those, who operate English as their second language and can bid for and take all the orders with standard pricing. Each writer has a possibility to become an Advanced Writer. The price for the orders that require an advanced knowledge is always higher than the standard one."
								),
								_react2.default.createElement(
									"p",
									null,
									"ENL writers are the native speakers of English and acquire academic knowledge in various subjects. The main advantage of being an ENL writer is the possibility to place the bid or take high-paid orders and complete more expensive assignments. Such writers also have a possibility to gain an Advanced Status, which will let you complete the orders at the highest pay-rate."
								),
								_react2.default.createElement(
									"h2",
									{ className: "inner-left-intext" },
									"What is the payment procedure?"
								),
								_react2.default.createElement(
									"p",
									null,
									"Convenient payment methods for most locations worldwide:"
								),
								_react2.default.createElement(
									"ul",
									null,
									_react2.default.createElement(
										"li",
										null,
										_react2.default.createElement("strong", { className: "inner-skrill" }),
										": you have to provide the company with your ",
										_react2.default.createElement("strong", { className: "inner-skrill" }),
										" account address"
									),
									_react2.default.createElement(
										"li",
										null,
										"Prepaid Debit MasterCard\xAE, Powered by ",
										_react2.default.createElement(
											"strong",
											null,
											"Payoneer"
										),
										": register at Payoneer.com through your home page with our company."
									),
									_react2.default.createElement(
										"li",
										null,
										_react2.default.createElement(
											"strong",
											null,
											"Wire transfer"
										),
										": this option is available for payouts starting at $300."
									),
									_react2.default.createElement(
										"li",
										null,
										"Regular payouts are easily managed. You can request payment between the 1st and the 3rd, or between the 15th and the 18th of every month."
									)
								)
							),
							_react2.default.createElement(
								"div",
								{ className: "col-md-4" },
								_react2.default.createElement(
									"div",
									{ id: "sidebar", className: "sidebar" },
									_react2.default.createElement(
										"div",
										{ id: "sidebar-scroll", className: "sidebar-scroll" },
										_react2.default.createElement(
											"div",
											{ className: "sidebar-img" },
											_react2.default.createElement("img", { src: _pricingPolicy2.default, alt: "Pricing Policy" })
										)
									)
								)
							)
						)
					),
					_react2.default.createElement(
						"div",
						{ className: "home-block home-block-gray" },
						_react2.default.createElement(
							"div",
							{ className: "container" },
							_react2.default.createElement(
								"h2",
								null,
								"Current projects offered"
							),
							_react2.default.createElement(
								"div",
								{ className: "row" },
								_react2.default.createElement(
									"div",
									{ className: "col-sm-6" },
									_react2.default.createElement(
										"div",
										{ className: "home-block-img" },
										_react2.default.createElement("img", { src: _currentProjects2.default, alt: "Current projects offered" })
									)
								),
								_react2.default.createElement(
									"div",
									{ className: "col-sm-6 home-current-projects-text" },
									_react2.default.createElement(
										"p",
										null,
										"Average order price: ",
										_react2.default.createElement(
											"strong",
											{ className: "home-teal-color" },
											"$",
											this.state.average
										)
									),
									_react2.default.createElement(
										"p",
										null,
										"Currently available orders: ",
										_react2.default.createElement(
											"strong",
											{ className: "home-teal-color" },
											this.state.averageOrders
										)
									),
									_react2.default.createElement(
										"p",
										{ className: "home-current-projects-link" },
										_react2.default.createElement(
											_gatsbyLink2.default,
											{ to: "/view_all_orders.html" },
											"View all orders ",
											_react2.default.createElement(
												"svg",
												{ id: "arrow-right", width: "22", height: "22" },
												_react2.default.createElement("path", { fill: "#f29f22", d: "M17.2,10.2l-3.2,3c-0.1,0.1-0.2,0.1-0.3,0c-0.1,0-0.2-0.1-0.2-0.2v-1.9H3c-0.2,0-0.3-0.1-0.3-0.3V9.2 C2.8,9,2.9,8.9,3,8.9h10.5V7.1c0-0.1,0.1-0.2,0.2-0.2c0.1,0,0.2,0,0.3,0l3.2,2.9c0.1,0.1,0.1,0.1,0.1,0.2 C17.2,10.1,17.2,10.1,17.2,10.2z" })
											)
										)
									)
								)
							)
						)
					),
					_react2.default.createElement(
						"div",
						{ className: "inner-registration inner-registration-white" },
						_react2.default.createElement(
							"div",
							{ className: "container" },
							_react2.default.createElement(
								"div",
								{ className: "inner-registration-text" },
								_react2.default.createElement(
									"div",
									{ className: "inner-registration-title" },
									"Register now ",
									_react2.default.createElement("br", null),
									"to start earning!"
								),
								_react2.default.createElement(
									"div",
									{ className: "inner-registration-button" },
									_react2.default.createElement(
										_gatsbyLink2.default,
										{ to: "/register_email.html" },
										"Start registration"
									)
								)
							),
							_react2.default.createElement(
								"div",
								{ className: "inner-registration-image" },
								_react2.default.createElement(
									"div",
									{ className: "img inner-registration-img" },
									_react2.default.createElement("img", { src: _registerNow2.default, alt: "Start registration" })
								)
							)
						)
					),
					_react2.default.createElement(_footer2.default, null)
				),
				_react2.default.createElement("div", { id: "mask", className: "c-mask" })
			);
		};
	
		return Pricing_policy;
	}(_react2.default.Component);
	
	exports.default = Pricing_policy;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-prices-html-js-bc309fa38cd496bd984e.js